import {
  ExternalMeasurementTagSettingType,
  GoogleTagManagerSetting,
} from 'backend';
import {
  GoogleAnalytics4Setting,
  GoogleGlobalSiteTagPageCommandType,
  UniversalAnalyticsSetting,
} from 'backend';
import { mappedConst } from 'shared';

export const EXTERNAL_MEASUREMENT_TAG_TYPE: mappedConst<ExternalMeasurementTagSettingType> =
  {
    UniversalAnalytics: 'UniversalAnalytics',
    GoogleAnalytics4: 'GoogleAnalytics4',
    GoogleTagManager: 'GoogleTagManager',
  };

export const GTAG_LOAD_SCRIPT_ELEMENT_ID = 'synergyGtagLoadScriptElementId';
export const GTAG_INITIALIZE_SCRIPT_ELEMENT_ID =
  'synergyGtagInitializeScriptElementId';

const GTM_LOAD_SCRIPT_ELEMENT_ID_Prefix = 'synergyGtmLoadScriptElementId';
export const getGtmLoadScriptElementId = (containerId: string) =>
  `${GTM_LOAD_SCRIPT_ELEMENT_ID_Prefix}_${containerId}` as const;

const GTM_DATA_LAYER_NAME_PREFIX = 'dataLayer';
// フォーム設置した場合、設置先サイトと新フォームで同一コンテナの GTM を設定した場合に新フォームの GTM が発火しない問題が起きた
// データレイヤー名が設置先サイトと新フォームと違うことが原因だったため、デフォルトの dataLayer を返すこととした
// see: https://gitlab.dev-internal.crmstyle.com/synergy/newt/form/portal/-/issues/4020
export const getGtmDataLayerName = () =>
  `${GTM_DATA_LAYER_NAME_PREFIX}` as const;

export const GTAG_PAGE_COMMAND_TYPE: mappedConst<GoogleGlobalSiteTagPageCommandType> =
  {
    config: 'config',
    event: 'event',
    set: 'set',
    get: 'get',
    consent: 'consent',
  };

export type MeasurementSettingHandledByGtag =
  | GoogleAnalytics4Setting
  | UniversalAnalyticsSetting;

// eslint-disable-next-line @typescript-eslint/ban-types
type DataLayer = { [key: string]: object };
const parseDataLayerToJson = (obj: DataLayer): any => {
  try {
    return JSON.parse(JSON.stringify(obj));
  } catch {
    return undefined;
  }
};

export const insertDataLayers = (
  dataLayerName: string,
  dataLayers: GoogleTagManagerSetting['dataLayers'],
): void => {
  if (!Array.isArray((window as any)[dataLayerName])) {
    (window as any)[dataLayerName] = [];
  }

  dataLayers.forEach((dataLayer) => {
    const data = parseDataLayerToJson(dataLayer);
    if (data) {
      (window as any)[dataLayerName]?.push(data);
    }
  });
};
